"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GetPackages;
var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard3(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _externalContext = _interopRequireDefault(require("common-components/dist/common/components/App/externalContext"));
var style = require("./style_css.js")["default"];
var containers = {};
function getPackages() {
  return _getPackages.apply(this, arguments);
}
function _getPackages() {
  _getPackages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee10() {
    var THREE, postprocessing, _yield$import, LineMaterial, _yield$import2, OBJLoader, _yield$import3, OrbitControls, _yield$import4, MTLLoader, _yield$import5, LineGeometry, _yield$import6, LineSegments2, _yield$import7, Sky;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three"));
          });
        case 2:
          THREE = _context10.sent;
          _context10.next = 5;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("postprocessing"));
          });
        case 5:
          postprocessing = _context10.sent;
          _context10.next = 8;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/lines/LineMaterial.js"));
          });
        case 8:
          _yield$import = _context10.sent;
          LineMaterial = _yield$import.LineMaterial;
          _context10.next = 12;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/loaders/OBJLoader.js"));
          });
        case 12:
          _yield$import2 = _context10.sent;
          OBJLoader = _yield$import2.OBJLoader;
          _context10.next = 16;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/controls/OrbitControls.js"));
          });
        case 16:
          _yield$import3 = _context10.sent;
          OrbitControls = _yield$import3.OrbitControls;
          _context10.next = 20;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/loaders/MTLLoader.js"));
          });
        case 20:
          _yield$import4 = _context10.sent;
          MTLLoader = _yield$import4.MTLLoader;
          _context10.next = 24;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/lines/LineGeometry.js"));
          });
        case 24:
          _yield$import5 = _context10.sent;
          LineGeometry = _yield$import5.LineGeometry;
          _context10.next = 28;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/lines/LineSegments2.js"));
          });
        case 28:
          _yield$import6 = _context10.sent;
          LineSegments2 = _yield$import6.LineSegments2;
          _context10.next = 32;
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2["default"])(require("three/examples/jsm/objects/Sky.js"));
          });
        case 32:
          _yield$import7 = _context10.sent;
          Sky = _yield$import7.Sky;
          return _context10.abrupt("return", {
            THREE: THREE,
            postprocessing: postprocessing,
            LineMaterial: LineMaterial,
            OBJLoader: OBJLoader,
            OrbitControls: OrbitControls,
            MTLLoader: MTLLoader,
            LineGeometry: LineGeometry,
            LineSegments2: LineSegments2,
            Sky: Sky
          });
        case 35:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _getPackages.apply(this, arguments);
}
function GetPackages(props) {
  var externalContext = (0, _react.useContext)(_externalContext["default"]);
  var _externalContext$exte = externalContext.externalSettings,
    externalSettings = _externalContext$exte === void 0 ? {} : _externalContext$exte;
  var _useState = (0, _react.useState)(externalSettings.packages),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    packages = _useState2[0],
    _setPackages = _useState2[1];
  function setPackages() {
    return _setPackages2.apply(this, arguments);
  }
  function _setPackages2() {
    _setPackages2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      var packages;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getPackages();
          case 2:
            packages = _context.sent;
            _context.next = 5;
            return _setPackages(packages);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _setPackages2.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (!packages) {
      setPackages();
    }
  }, [packages]);
  return packages ? /*#__PURE__*/_react["default"].createElement(Canvas, Object.assign({}, props, {
    packages: packages
  })) : null;
}
function Canvas(props) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var wapp = context.wapp;
  var fullPage = props.fullPage,
    packages = props.packages,
    progressRef = props.progressRef,
    editor = props.editor,
    className = props.className;
  wapp.styles.use(style);
  var container = (0, _react.useRef)();
  var composition = (0, _react.useRef)();
  var compositionBg = (0, _react.useRef)();
  if (!containers[wapp.globals.WAPP]) {
    containers[wapp.globals.WAPP] = {};
  }
  (0, _react.useEffect)(function didMount() {
    var THREE = packages.THREE,
      postprocessing = packages.postprocessing,
      OBJLoader = packages.OBJLoader,
      MTLLoader = packages.MTLLoader,
      OrbitControls = packages.OrbitControls,
      Sky = packages.Sky;
    var SelectiveBloomEffect = postprocessing.SelectiveBloomEffect,
      EffectPass = postprocessing.EffectPass,
      EffectComposer = postprocessing.EffectComposer,
      RenderPass = postprocessing.RenderPass,
      KernelSize = postprocessing.KernelSize,
      BlendFunction = postprocessing.BlendFunction,
      BloomEffect = postprocessing.BloomEffect,
      TextureEffect = postprocessing.TextureEffect;
    containers[wapp.globals.WAPP].current = container.current;
    var scene;
    var camera;
    var composer;
    var renderer;
    var raycaster;
    var pointer = new THREE.Vector2();
    var selectiveBloomEffect;
    var reqId = null;
    var removeInputListeners;
    var controls;
    var target;
    var userCameraMoveing = false;
    var removeControlListeners;
    var enableOrbitControls = wapp.globals.DEV;
    var bgRenderer;
    var bgScene;
    var bgCamera;
    var bgComposer;
    var cloudParticles = [];
    var cloudGeo;
    var cloudMaterial;
    var boxes;
    var animInt;
    var toggleTimeouts = {};
    var runnings = [];
    function initBgGraphics() {
      var parentContainer = containers[wapp.globals.WAPP].current || typeof window !== "undefined" && window;
      bgScene = new THREE.Scene();
      bgScene.background = new THREE.Color(0xe5693e);

      /*Camera, Renderer*/

      bgCamera = new THREE.PerspectiveCamera(60, parentContainer.offsetWidth / parentContainer.offsetHeight, 0.01, 1000);
      bgRenderer = new THREE.WebGLRenderer({
        antialias: true,
        canvas: compositionBg.current,
        alpha: false,
        powerPreference: "high-performance",
        stencil: false
      });
      bgRenderer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
      bgRenderer.shadowMap.enabled = true;
      bgRenderer.shadowMap.type = THREE.PCFSoftShadowMap;
      bgRenderer.toneMappingExposure = 0.6;
      bgRenderer.toneMapping = THREE.ACESFilmicToneMapping;

      /*Lights*/

      var hemiLight = new THREE.HemisphereLight(0x3d4044, 0x3d4044, 1.8);
      var ambient = new THREE.AmbientLight(0x555555);
      var directionalLight = new THREE.DirectionalLight(0xff8c19);
      directionalLight.position.set(0, 0, -1);
      var orangeLight = new THREE.PointLight(0xcc6600, 5, 500, 1.7);
      orangeLight.position.set(-50, 150, 150);
      var redLight = new THREE.PointLight(0xd8547e, 10, 500, 1.7);
      redLight.position.set(0, 150, 150);
      var blueLight = new THREE.PointLight(0x3677ac, 5, 500, 1.7);
      blueLight.position.set(50, 150, 150);

      /*Fog*/

      bgScene.fog = new THREE.FogExp2(0x111116, 0.007);

      //bgRenderer.setClearColor(bgScene.fog.color);

      /*Clouds*/

      var loader = new THREE.TextureLoader();
      var clouds = new THREE.Object3D();
      clouds.position.set(0, 0, 100);
      loader.load("/assets/atonement-the-victim/smoke.png", function (texture) {
        cloudGeo = new THREE.PlaneBufferGeometry(100, 100);
        cloudMaterial = new THREE.MeshLambertMaterial({
          map: texture,
          transparent: true
        });
        for (var p = 0; p < 50; p++) {
          var cloud = new THREE.Mesh(cloudGeo, cloudMaterial);
          cloud.position.set(Math.random() * 200 - 100, Math.random() * 100, Math.random() * 100);
          cloud.material.opacity = 0.55;
          cloud.rotation.z = Math.random() * 2 * Math.PI;
          cloud.rotation.y = Math.PI;
          cloudParticles.push(cloud);
          clouds.add(cloud);
        }
      });
      loader.load("/assets/atonement-the-victim/stars.jpg", function (texture) {
        var textureEffect = new TextureEffect({
          blendFunction: BlendFunction.COLOR_DODGE,
          texture: texture
        });
        textureEffect.blendMode.opacity.value = 0.2;
        var bloomEffect = new BloomEffect({
          blendFunction: BlendFunction.COLOR_DODGE,
          kernelSize: KernelSize.SMALL,
          useLuminanceFilter: true,
          luminanceThreshold: 0.3,
          luminanceSmoothing: 0.75
        });
        bloomEffect.blendMode.opacity.value = 1.5;
        var effectPass = new EffectPass(bgCamera, bloomEffect, textureEffect);
        effectPass.renderToScreen = true;
        bgComposer.addPass(effectPass);
      });

      /*Background effect composer*/

      bgComposer = new EffectComposer(bgRenderer);
      bgComposer.addPass(new RenderPass(bgScene, bgCamera));

      /*Sky*/

      var sky = new Sky();
      sky.scale.setScalar(10000);
      var skyUniforms = sky.material.uniforms;
      skyUniforms["turbidity"].value = 4;
      skyUniforms["rayleigh"].value = 5;
      skyUniforms["mieCoefficient"].value = 0.005;
      skyUniforms["mieDirectionalG"].value = 0.8;
      var pmremGenerator = new THREE.PMREMGenerator(bgRenderer);
      var phi = THREE.MathUtils.degToRad(91);
      var theta = THREE.MathUtils.degToRad(20);
      var sun = new THREE.Vector3();
      sun.setFromSphericalCoords(1, phi, theta);
      sky.material.uniforms["sunPosition"].value.copy(sun);
      bgScene.environment = pmremGenerator.fromScene(sky).texture;

      /*Scene add*/

      bgScene.add(hemiLight);
      bgScene.add(ambient);
      bgScene.add(directionalLight);
      bgScene.add(orangeLight);
      bgScene.add(redLight);
      bgScene.add(blueLight);
      bgScene.add(sky);
      bgScene.add(clouds);
    }
    var addedObjects = false;
    function initGraphics() {
      var parentContainer = containers[wapp.globals.WAPP].current || typeof window !== "undefined" && window;
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(60, parentContainer.offsetWidth / parentContainer.offsetHeight, 0.01, 1000);
      window.camera = camera;
      camera.position.z = -1;
      camera.position.y = 1.86;
      camera.position.x = 0.05;
      target = new THREE.Vector3(0.05, 1.83, 1.5);
      camera.lookAt(target.x, target.y, target.z);
      raycaster = new THREE.Raycaster();
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        canvas: composition.current,
        alpha: true,
        powerPreference: "high-performance",
        stencil: false
      });
      renderer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      renderer.autoClear = false;
      renderer.toneMappingExposure = Math.pow(1, 4.0);
      var renderScene = new RenderPass(scene, camera);
      selectiveBloomEffect = new SelectiveBloomEffect(scene, camera, {
        blendFunction: BlendFunction.SCREEN,
        kernelSize: KernelSize.MEDIUM,
        luminanceThreshold: 0.4,
        luminanceSmoothing: 0.2,
        intensity: 1
      });
      var bloomEffect = new EffectPass(camera, selectiveBloomEffect);
      bloomEffect.renderToScreen = true;
      composer = new EffectComposer(renderer);
      composer.addPass(renderScene);
      composer.addPass(bloomEffect);

      /*Ground*/

      var groundGeo = new THREE.PlaneGeometry(5000, 2);
      var groundMat = new THREE.MeshLambertMaterial({
        color: 0x6b6e66
      });
      var ground = new THREE.Mesh(groundGeo, groundMat);
      ground.position.y = 1;
      ground.position.z = 1;
      ground.rotation.x = -Math.PI / 2;
      ground.receiveShadow = true;
      var groundY = ground.position.y;
      var boxMaterialProps = {
        roughness: 3,
        bumpScale: 0.008,
        metalness: 0.2
      };

      /*Boxes*/

      boxes = new THREE.Group();
      var boxGeometryProps = [100, 100];
      var box0 = new THREE.Mesh((0, _construct2["default"])(THREE.BoxGeometry, [0.14, 0.15, 0.15].concat(boxGeometryProps)), new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({
        color: 0xff474d
      }, boxMaterialProps)));
      box0.position.set(0.435, groundY + 0.15 / 2, 0.925);
      box0.receiveShadow = true;
      box0.castShadow = true;
      boxes.add(box0);
      var box1 = new THREE.Mesh((0, _construct2["default"])(THREE.BoxGeometry, [0.14, 0.15, 0.3].concat(boxGeometryProps)), new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({
        color: 0xff474d
      }, boxMaterialProps)));
      box1.position.set(0.295, groundY + 0.15 / 2, 1);
      box1.receiveShadow = true;
      box1.castShadow = true;
      boxes.add(box1);
      var box2 = new THREE.Mesh((0, _construct2["default"])(THREE.BoxGeometry, [0.25, 0.25, 0.25].concat(boxGeometryProps)), new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({
        color: 0x28ddb7
      }, boxMaterialProps)));
      box2.position.set(0.1, groundY + 0.25 / 2, 1);
      box2.receiveShadow = true;
      box2.castShadow = true;
      boxes.add(box2);
      var box3 = new THREE.Mesh((0, _construct2["default"])(THREE.BoxGeometry, [0.20, 0.18, 0.18].concat(boxGeometryProps)), new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({
        color: 0x28ddb7
      }, boxMaterialProps)));
      box3.position.set(-0.115, groundY + 0.18 / 2, 1.05);
      box3.receiveShadow = true;
      box3.castShadow = true;
      boxes.add(box3);
      var box4 = new THREE.Mesh((0, _construct2["default"])(THREE.BoxGeometry, [0.36, 0.4, 0.18].concat(boxGeometryProps)), new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({
        color: 0x28ddb7
      }, boxMaterialProps)));
      box4.position.set(-0.115 - 0.27, groundY + 0.4 / 2, 1.05);
      box4.receiveShadow = true;
      box4.castShadow = true;
      boxes.add(box4);
      var box5 = new THREE.Mesh((0, _construct2["default"])(THREE.BoxGeometry, [0.36, 0.18, 0.08].concat(boxGeometryProps)), new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({
        color: 0xff8a40
      }, boxMaterialProps)));
      box5.position.set(-0.115 - 0.27, groundY + 0.18 / 2, 0.92);
      box5.receiveShadow = true;
      box5.castShadow = true;
      boxes.add(box5);
      var box6 = new THREE.Mesh((0, _construct2["default"])(THREE.BoxGeometry, [0.18, 0.3, 0.6].concat(boxGeometryProps)), new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({
        color: 0x28ddb7
      }, boxMaterialProps)));
      box6.position.set(-0.115, groundY + 0.3 / 2, 1.44);
      box6.receiveShadow = true;
      box6.castShadow = true;
      boxes.add(box6);
      var box7 = new THREE.Mesh((0, _construct2["default"])(THREE.BoxGeometry, [0.36, 0.2, 0.2].concat(boxGeometryProps)), new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({
        color: 0x28ddb7
      }, boxMaterialProps)));
      box7.position.set(-0.28, groundY + 0.28 + 0.18 / 2, 1);
      box7.receiveShadow = true;
      box7.castShadow = true;
      boxes.add(box7);
      var box8 = new THREE.Mesh((0, _construct2["default"])(THREE.BoxGeometry, [0.14, 0.14, 0.26].concat(boxGeometryProps)), new THREE.MeshStandardMaterial((0, _objectSpread2["default"])({
        color: 0xa84142
      }, boxMaterialProps)));
      box8.position.set(-0.38, groundY + 0.28 + 0.18 / 2 + 0.2 / 2 + 0.14 / 2, 1.12);
      box8.receiveShadow = true;
      box8.castShadow = true;
      boxes.add(box8);
      var body;
      new MTLLoader().setMaterialOptions({
        side: THREE.DoubleSide
      }).load("/assets/atonement-the-victim/obj/body/body.mtl", function (materials) {
        materials.preload();
        new OBJLoader().setMaterials(materials).load("/assets/atonement-the-victim/obj/body/body.obj", function (object) {
          body = object;
          body.scale.x = 0.8;
          body.scale.y = 0.8;
          body.scale.z = 0.8;
          body.position.y = 1.1;
          body.position.x = 0.8;
          body.position.z = 1.1;
          body.rotation.set(-Math.PI / 8, Math.PI / 2, 0);
          body.castShadow = true;
          body.receiveShadow = true;
          body.traverse(function (child) {
            child.castShadow = true;
          });
          scene.add(body);
          setTimeout( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
            var _progressRef$current, _progressRef$current$;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(progressRef !== null && progressRef !== void 0 && (_progressRef$current = progressRef.current) !== null && _progressRef$current !== void 0 && (_progressRef$current$ = _progressRef$current.actions) !== null && _progressRef$current$ !== void 0 && _progressRef$current$.setShow)) {
                    _context2.next = 3;
                    break;
                  }
                  _context2.next = 3;
                  return progressRef.current.actions.setShow({
                    message: "",
                    value: false
                  });
                case 3:
                  console.log("[APP] Add objects...");
                  console.log("[APP] Call onComplete...");
                  addedObjects = true;
                case 6:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          })), 2000);
        }, function (xhr) {}, /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(error) {
            var _progressRef$current2, _progressRef$current3;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  console.log(error);
                  if (!(progressRef !== null && progressRef !== void 0 && (_progressRef$current2 = progressRef.current) !== null && _progressRef$current2 !== void 0 && (_progressRef$current3 = _progressRef$current2.actions) !== null && _progressRef$current3 !== void 0 && _progressRef$current3.setShow)) {
                    _context3.next = 4;
                    break;
                  }
                  _context3.next = 4;
                  return progressRef.current.actions.setShow({
                    message: "",
                    value: false
                  });
                case 4:
                  console.log("[APP] Add objects...");
                  console.log("[APP] Call onComplete...");
                  addedObjects = true;
                case 7:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
      var spotLight = new THREE.SpotLight(0xffffff, 1);
      spotLight.shadow.camera.near = 0.01;
      spotLight.shadow.camera.far = 10;
      spotLight.lookAt(0, 0, 0);
      spotLight.castShadow = true;
      spotLight.position.set(-1, 3, 0);
      spotLight.lookAt(0, 0, 0);
      spotLight.shadow.mapSize.width = 4096;
      spotLight.shadow.mapSize.height = 4096;
      var hemiLight = new THREE.HemisphereLight(0xddeeff, 0x0f0e0d, 0.5);
      scene.add(hemiLight);
      scene.add(spotLight);
      scene.add(ground);
      scene.add(boxes);
    }
    function initControls() {
      controls = new OrbitControls(camera, renderer.domElement);
      controls.target = target;
      controls.update();
      if (!enableOrbitControls) {
        controls.enableZoom = false;
        controls.enablePan = false;
        controls.enableDamping = false;
        controls.minPolarAngle = Math.PI / 2 - 0.5;
        controls.maxPolarAngle = Math.PI / 2 + 0.1;
        controls.minAzimuthAngle = camera.rotation.y - 3.3;
        controls.maxAzimuthAngle = camera.rotation.y - 3.05;
      }
      var wait;
      var start = function start() {
        if (wait) {
          clearTimeout(wait);
        }
        userCameraMoveing = 1;
      };
      var end = function end() {
        if (wait) {
          clearTimeout(wait);
        }
        userCameraMoveing = 1;
        wait = setTimeout(function () {
          userCameraMoveing = 0;
        }, 100);
      };
      removeControlListeners = function removeControlListeners() {
        controls.removeEventListener("start", start);
        controls.removeEventListener("end", end);
      };
      controls.addEventListener("start", start);
      controls.addEventListener("end", end);
    }
    function glow(object) {
      if (object) {
        var isActive = object.userData.isActive;
        if (isActive) {
          if (object.userData.tempMaterial) {
            object.material = object.userData.tempMaterial;
          }
          object.userData.isActive = false;
        } else {
          var _object$userData$temp;
          var color = 0x28ddb7;
          if (!object.userData.tempMaterial) {
            object.userData.tempMaterial = object.material;
          }
          if ((_object$userData$temp = object.userData.tempMaterial) !== null && _object$userData$temp !== void 0 && _object$userData$temp.color) {
            color = object.userData.tempMaterial.color;
          }
          object.material = new THREE.MeshBasicMaterial({
            color: color,
            transparent: true,
            opacity: 0.9
          });
          object.userData.isActive = true;
        }
        var selection = selectiveBloomEffect.selection;
        if (object.userData.isActive) {
          if (!selection.has(object)) {
            selection.add(object);
          }
        } else {
          if (selection.has(object)) {
            selection["delete"](object);
          }
        }
      }
    }
    function initInput() {
      var doClickOnRelease = false;
      var click = function click(event) {
        if (doClickOnRelease) {
          var _intersects$;
          pointer.x = event.clientX / window.innerWidth * 2 - 1;
          pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
          raycaster.setFromCamera(pointer, camera);
          var intersects = raycaster.intersectObjects(boxes.children, true);
          var object = (_intersects$ = intersects[0]) === null || _intersects$ === void 0 ? void 0 : _intersects$.object;
          glow(object);
        }
      };
      var down = function down() {
        doClickOnRelease = true;
      };
      var move = function move() {
        if (enableOrbitControls) {
          doClickOnRelease = false;
        }
      };
      container.current.addEventListener("click", click);
      container.current.addEventListener("mousedown", down);
      container.current.addEventListener("mousemove", move);
      container.current.addEventListener("touchstart", down);
      container.current.addEventListener("touchmove", move);
      removeInputListeners = function removeInputListeners() {
        if (container.current) {
          container.current.removeEventListener("click", click);
          container.current.removeEventListener("mousedown", down);
          container.current.removeEventListener("mousemove", move);
          container.current.removeEventListener("touchstart", down);
          container.current.removeEventListener("touchmove", move);
        }
      };
    }
    function initAnim() {
      var totalTime = 5000;
      var toggleTime = totalTime / 2 / boxes.children.length;
      function toggleAndAgain(key, wait) {
        var object = boxes.children[key];
        if (object) {
          glow(object);
          if (toggleTimeouts[key]) {
            clearTimeout(toggleTimeouts[key]);
          }
          toggleTimeouts[key] = setTimeout(function () {
            return glow(object);
          }, wait);
        }
      }
      function runAll(_x2, _x3, _x4, _x5, _x6) {
        return _runAll.apply(this, arguments);
      }
      function _runAll() {
        _runAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(keys, run, wait, runAllEnd, m) {
          var i, next, _next;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                _next = function _next3() {
                  _next = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(m) {
                    var key;
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
                      while (1) switch (_context6.prev = _context6.next) {
                        case 0:
                          key = keys[i];
                          if (!(typeof key !== "undefined" && !(m !== null && m !== void 0 && m.stop))) {
                            _context6.next = 11;
                            break;
                          }
                          _context6.next = 4;
                          return run(key, wait);
                        case 4:
                          i = i + 1;
                          _context6.next = 7;
                          return new Promise(function (resolve) {
                            setTimeout(resolve, wait);
                          });
                        case 7:
                          _context6.next = 9;
                          return next(m);
                        case 9:
                          _context6.next = 15;
                          break;
                        case 11:
                          _context6.next = 13;
                          return Promise.all(keys.map( /*#__PURE__*/function () {
                            var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(key) {
                              return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
                                while (1) switch (_context5.prev = _context5.next) {
                                  case 0:
                                    _context5.next = 2;
                                    return runAllEnd(key);
                                  case 2:
                                    return _context5.abrupt("return", _context5.sent);
                                  case 3:
                                  case "end":
                                    return _context5.stop();
                                }
                              }, _callee5);
                            }));
                            return function (_x8) {
                              return _ref4.apply(this, arguments);
                            };
                          }()));
                        case 13:
                          m.stop = true;
                          runnings.splice(runnings.indexOf(m));
                        case 15:
                        case "end":
                          return _context6.stop();
                      }
                    }, _callee6);
                  }));
                  return _next.apply(this, arguments);
                };
                next = function _next2(_x7) {
                  return _next.apply(this, arguments);
                };
                if (runnings.length) {
                  runnings.forEach(function (runningObject) {
                    runningObject.stop = true;
                  });
                }
                runnings.push(m);
                i = 0;
                _context7.next = 7;
                return next(m);
              case 7:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        return _runAll.apply(this, arguments);
      }
      var run3 = -1;
      function shuffleAndRun() {
        return _shuffleAndRun.apply(this, arguments);
      }
      function _shuffleAndRun() {
        _shuffleAndRun = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8() {
          var keys, _i, j, _ref5;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                keys = Array.from({
                  length: boxes.children.length
                }, function (v, i) {
                  return i;
                });
                for (_i = keys.length - 1; _i > 0; _i--) {
                  j = Math.floor(Math.random() * (_i + 1));
                  _ref5 = [keys[j], keys[_i]];
                  keys[_i] = _ref5[0];
                  keys[j] = _ref5[1];
                }
                _context8.next = 4;
                return runAll(keys, toggleAndAgain, toggleTime, function (key) {
                  return toggleAndAgain(key, toggleTime * 2);
                }, {});
              case 4:
                if (addedObjects && run3 < 3) {
                  run3 = run3 + 1;
                  if (run3 === 3) {
                    run3 = -1;
                    console.log("[APP] Animation ended 0");
                  }
                }
              case 5:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        return _shuffleAndRun.apply(this, arguments);
      }
      if (animInt) {
        clearInterval(animInt);
      }
      animInt = setInterval( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return shuffleAndRun();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })), totalTime);
      shuffleAndRun();
    }
    var render = function render() {
      if (reqId) {
        cancelAnimationFrame(reqId);
      }
      reqId = requestAnimationFrame(render);
      if (controls) {
        controls.update();
      }
      bgCamera.rotation.set(camera.rotation.x, camera.rotation.y, camera.rotation.z);
      bgCamera.position.set(camera.position.x, camera.position.y, camera.position.z);
      cloudParticles.forEach(function (p) {
        p.rotation.z -= 0.1;
      });
      bgComposer.render(0.1);
      composer.render();
    };
    function init() {
      initBgGraphics();
      initGraphics();
      initControls();
      render();
      initInput();
      initAnim();
    }
    init();
    function onResize() {
      if (camera && renderer) {
        var parentContainer = containers[wapp.globals.WAPP].current || typeof window !== "undefined" && window;
        camera.aspect = parentContainer.offsetWidth / parentContainer.offsetHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
        composer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
        bgCamera.aspect = parentContainer.offsetWidth / parentContainer.offsetHeight;
        bgCamera.updateProjectionMatrix();
        bgRenderer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
        bgComposer.setSize(parentContainer.offsetWidth, parentContainer.offsetHeight);
      }
    }
    function addResizeListeners() {
      if (container.current && typeof ResizeObserver !== "undefined") {
        var resizeObserver = new ResizeObserver(function (entries) {
          onResize(entries);
        });
        resizeObserver.observe(container.current);
        return function removeEventListener() {
          resizeObserver.disconnect();
        };
      } else {
        window.addEventListener("resize", onResize);
        return function removeEventListener() {
          window.removeEventListener("resize", onResize);
        };
      }
    }
    var removeResizeListeners = addResizeListeners();
    onResize();
    return function willUnmount() {
      removeResizeListeners();
      if (removeInputListeners) {
        removeInputListeners();
      }
      if (removeControlListeners && controls) {
        removeControlListeners();
      }
      if (reqId) {
        cancelAnimationFrame(reqId);
        if (animInt) {
          clearInterval(animInt);
        }
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    var handleKeyDown = function handleKeyDown(e) {
      var isCtrl = e.ctrlKey;
      if (isCtrl || !editor) {
        if (e.key === "5") {
          var save = /*#__PURE__*/function () {
            var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    _context9.next = 2;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, 1000);
                    });
                  case 2:
                    console.log("[APP]", "Saving...");
                    _context9.next = 5;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, 1000);
                    });
                  case 5:
                    window.dataForServerSaving = {
                      blob: null
                    };
                    console.log("[APP]", "The data for server saving is ready...");
                  case 7:
                  case "end":
                    return _context9.stop();
                }
              }, _callee9);
            }));
            return function save() {
              return _ref6.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          save();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return function () {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx3["default"])(style.canvas, (0, _defineProperty2["default"])({}, style.fullPage, fullPage), (0, _defineProperty2["default"])({}, className, className)),
    ref: container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.bg
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: style.center
  }, /*#__PURE__*/_react["default"].createElement("canvas", {
    className: style.compositionBg,
    ref: compositionBg
  }), /*#__PURE__*/_react["default"].createElement("canvas", {
    className: style.composition,
    ref: composition
  })));
}